import _typeof from "@babel/runtime/helpers/typeof";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Mark } from 'slate';
export var createMark = function createMark(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      rawType = _ref2[0],
      data = _ref2[1];

  if (rawType.indexOf(':') >= 0) {
    var _rawType$split = rawType.split(':'),
        _rawType$split2 = _slicedToArray(_rawType$split, 2),
        type = _rawType$split2[0],
        id = _rawType$split2[1];

    return Mark.create({
      type: type,
      data: {
        id: id
      }
    });
  } else if (data && _typeof(data) === 'object') {
    return Mark.create({
      type: data.type || rawType,
      data: data
    });
  } else {
    return Mark.create({
      type: rawType
    });
  }
};
export default function convertAttributesToMarks(attributes) {
  return Mark.createSet(Object.entries(attributes).map(createMark));
}